<template>
	<div>
		<TimerControl @subcommand="subcommand" v-if="slide.settings.timer"></TimerControl>
	</div>
</template>

<script>
import BaseSlide from './BaseSlide';
import TimerControl from '../controls/TimerControl';

export default {
	name: 'DiceSlide',
	mixins: [BaseSlide],
	components: {
		TimerControl,
	},
};
</script>

<style></style>
